angular.module('gym.website').controller('WebsiteCtrl', ["website", "flash", "loadingAnimation", "$scope", "$state", "$window", "$rootScope", "$q", "$http", "GTMService", "MobileApp", function(website, flash, loadingAnimation, $scope, $state, $window, $rootScope, $q, $http, GTMService, MobileApp) {
  var gym;
  $scope.gym = gym = $rootScope.gym;
  $scope.website = website;
  $scope.isState = function(state) {
    return $state.is(state);
  };
  $scope.isCopySection = function() {
    var ref;
    return (ref = $state.current.name) === 'gym.website.homepage' || ref === 'gym.website.contactUs' || ref === 'gym.website.gallery' || ref === 'gym.website.tac' || ref === 'gym.website.requestMobileAppAccess';
  };
  $scope.isWebsiteCopyOpen = $scope.isCopySection();
  $scope.toggleWebsiteCopySidebar = function() {
    return $scope.isWebsiteCopyOpen = !$scope.isWebsiteCopyOpen;
  };
  if ($scope.gym.mobile_app_enabled) {
    MobileApp.all('settings').getList().then(function(data) {
      return $scope.mobileAppSettings = data.plain()[0];
    });
  }
  $scope.setMobileAppSettings = function(settings) {
    return $scope.mobileAppSettings = settings;
  };
  $scope.save = function(data) {
    var deferred, url;
    deferred = $q.defer();
    url = `gyms/${gym.id}/website`;
    $http.patch(url, {
      website: data
    }).then(function(response) {
      $scope.website = response.data;
      return deferred.resolve(response.data);
    }, function(response) {
      return deferred.reject(response.data);
    });
    return deferred.promise;
  };
  $scope.reloadWebsite = function() {
    var deferred;
    deferred = $q.defer();
    $http.get(`gyms/${gym.id}/website`).then(function(response) {
      $scope.website = response.data;
      return deferred.resolve(response.data);
    }, function() {
      return flash.error('Request could not be completed. Please try again');
    });
    return deferred.promise;
  };
  $scope.saveHomepage = function() {
    GTMService.trackPage('Website Copy Home Page', 'attempt');
    loadingAnimation.show();
    return $scope.save($scope.website).then(function() {
      GTMService.trackPage('Website Copy Home Page', 'success');
      flash.success = "Website details updated";
      return loadingAnimation.hide();
    }, function() {
      GTMService.trackPage('Website Copy Home Page', 'error');
      flash.error = "Save failed. Please make sure all of the required fields are filled out properly";
      return loadingAnimation.hide();
    });
  };
  $scope.tacSave = function() {
    GTMService.trackPage('Website Copy Terms And Conditions', 'attempt');
    loadingAnimation.show();
    return $scope.save($scope.website).then(function() {
      GTMService.trackPage('Website Copy Terms And Conditions', 'success');
      flash.success = "Website details updated";
      return loadingAnimation.hide();
    }, function() {
      GTMService.trackPage('Website Copy Terms And Conditions', 'error');
      flash.error = "Save failed. Please make sure all of the required fields are filled out properly";
      return loadingAnimation.hide();
    });
  };
  $scope.websiteUrl = function() {
    return `https://${window.location.host}/websites/${$scope.website.domain}`;
  };
  return $scope.onVisitWebsite = function() {
    return GTMService.trackPage('Manage Website - Business Details', 'click to open website');
  };
}]);
